// extracted by mini-css-extract-plugin
export var statItem = "_gu-1";
export var statsRow = "_gu-0";